import { render } from "./ScrollUpButton.vue?vue&type=template&id=6a967660&scoped=true"
import script from "./ScrollUpButton.vue?vue&type=script&lang=js"
export * from "./ScrollUpButton.vue?vue&type=script&lang=js"

import "./ScrollUpButton.vue?vue&type=style&index=0&id=6a967660&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a967660"]])

export default __exports__